module.exports = __webpack_public_path__ + "img/component-warning.ebb7f397.svg";